import { Component, OnInit } from '@angular/core';
import { MapService } from '../../map.service';
import { SearchService } from '../../search.service';
import { ProcessInput, TabService } from '../../tab.service';
import { ProcessInfo, UserService } from '../../user.service';
import { environment } from './../../../environments/environment';
import { Collection } from '../../data/collection';
import { Observable } from 'rxjs';

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-explorersidebar',
  templateUrl: './explorersidebar.component.html',
  styleUrls: ['./explorersidebar.component.css']
})

export class ExplorersidebarComponent implements OnInit {

  deployProcessView = false;

  constructor(public tabService: TabService, public userService: UserService, 
    public searchService: SearchService, public mapService: MapService) { 
    
    this.searchService.listCollections();
  }

  ngOnInit(): void {
  }

  selectProcess(process:any): void {
    this.tabService.selectedProcess = process;
    this.tabService.selectedProcessInputs.set([]);
    if (process) {
      this.userService.getProcessInputs(process).subscribe(data => { this.tabService.selectedProcessInputs.set(data); });
      this.tabService.toggleExplorerSidebar(this.tabService.explorerSideNavs.WORKSPACE);
    }
  }

  showDeployProcessView(): void {
    this.deployProcessView = true;
  }

  hideDeployProcessView(): void {
    this.deployProcessView = false;
  }

  deployProcess(): void {
    const inputElem = document.getElementById("cwlContent") as HTMLInputElement | null;
    let cwlContent = inputElem?.value;
    if (cwlContent && cwlContent.length > 0) {
      this.userService.deployProcess(cwlContent);
      this.hideDeployProcessView();
    } else {
      const selectElem = document.getElementById("builtInProcess") as HTMLInputElement | null;
      let processId = selectElem?.value;
      if (processId && processId != '') {
        for (let process of this.userService.availableBuiltInProcesses) {
          if (process.id == processId) {
            this.userService.deployProcess(environment.baseUrl + process.url);
            this.hideDeployProcessView();
            break;
          }
        }
      }
    }
  }

  undeployProcess(): void {
    this.userService.undeployProcess(this.tabService.selectedProcess);
    this.selectProcess(undefined);
    this.tabService.toggleExplorerSidebar(this.tabService.explorerSideNavs.SERVICES)
  }

  // Add another input field to a multivalued input
  // Input elements are automatically generated for each ID in the fieldids list
  addAnotherFieldForInput(input:ProcessInput): void {
    if (input.maxOccurs && input.maxOccurs > 1) {
      input.fieldids.push(input.tag + '_' + (input.fieldids.length+1).toString());
    }
  }

  launchProcess(): void {
    let data: any = {
      "inputs": {},
      "response": "raw"
    };
    // Add input definitions
    let inputs:ProcessInput[] = this.tabService.selectedProcessInputs();
    for (var i=0; i<inputs.length; i++) {
      let input:ProcessInput = inputs[i];
      if (input.maxOccurs && input.maxOccurs > 1) {
        let value:string[] = [];
        for (let fieldid of input.fieldids) {
          const inputElem = document.getElementById(fieldid) as HTMLInputElement | null;
          if (inputElem && inputElem.value) {
            value.push(inputElem.value);
          }
        }
        data.inputs[input.tag] = value;
      } else {
        let value:string = '';
        const inputElem = document.getElementById(input.tag) as HTMLInputElement | null;
        if (inputElem && inputElem.value) {
          value = inputElem.value;
        }
        data.inputs[input.tag] = value;
      }
      
      //console.log(input.tag + ":" + data.inputs[input.tag]);
    }
    //console.log(data);
    this.userService.launchProcess(this.tabService.selectedProcess, data);
  }

  searchCollection(): void {
    let inputElems = document.getElementsByClassName('searchInput');
    let searchConstraints:any = {};
    for (let i=0; i<inputElems.length; i++) {
      let inputElem = inputElems[i] as HTMLInputElement;
      searchConstraints[inputElem.id] = inputElem.value;
    }
    console.log(searchConstraints);
    this.searchService.searchCollection(searchConstraints);
  }
}

export interface BuiltInProcess {
  id: string;
  title: string;
  version: string;
  url: string;
  tag: string;
}